import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
	return twMerge(clsx(inputs));
}

export function normalizeFrequency(f) {
	if (!f) return '';
	const val = f.toString().toLowerCase().replace(/\s+/g, '-');
	// Normalize semi-annual/biannual variants to 6-monthly
	if (val === 'semi-annually' || val === 'semiannually' || val === 'biannually' || val === 'bi-annual' || val === 'semi-annual') return '6-monthly';
	return val;
}

/**
 * Get the correct frequency to use for checklist filtering
 * For hours-based tests, use the test_code (H8, H40, etc.)
 * For calendar-based tests, use the frequency (daily, weekly, etc.)
 */
export function getChecklistFrequency(task) {
	if (!task) return '';
	
	// Hours-based frequencies start with H followed by numbers
	const isHoursBased = task.type && /^H\d+$/i.test(task.type);
	
	if (isHoursBased) {
		// Use the test code (H8, H40, etc.) for hours-based
		return task.type.toUpperCase();
	}
	
	// For calendar-based tests, use frequency (or type as fallback)
	return normalizeFrequency(task.frequency || task.type || '');
}